import React from 'react';
import { Lead, EligibilityStatus } from '../types';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { EyeIcon } from 'lucide-react';
import { formatTimeAgo } from '../utils/time';
interface SentLeadsTableProps {
  leads: Lead[];
  onViewDetails: (lead: Lead, eligibility: EligibilityStatus) => void;
}
export function SentLeadsTable({
  leads,
  onViewDetails
}: SentLeadsTableProps) {
  if (leads.length === 0) {
    return <div className="p-8 text-center" data-id="element-128">
        <p className="text-sm text-gray-500" data-id="element-129">
          No leads sent during this period.
        </p>
      </div>;
  }
  return <div className="overflow-x-auto" data-id="element-130">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-131">
        <thead className="bg-gray-50/50" data-id="element-132">
          <tr data-id="element-133">
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-134">
              Lead Details
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-135">
              Source
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-136">
              Owner
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-137">
              Status
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-138">
              Sent
            </th>
            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-139">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-100" data-id="element-140">
          {leads.map(lead => <tr key={lead.id} className="group hover:bg-gray-50 transition-colors" data-id="element-141">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-142">
                <div className="flex items-center" data-id="element-143">
                  <div className="w-2 h-2 rounded-full mr-3 bg-blue-500" data-id="element-144" />
                  <div data-id="element-145">
                    <button onClick={() => onViewDetails(lead, 'Sent')} className="text-sm font-medium text-gray-900 hover:text-indigo-600 transition-colors" data-id="element-146">
                      {lead.name}
                    </button>
                    <div className="text-xs text-gray-500" data-id="element-147">{lead.phone}</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-148">
                <span className="text-sm text-gray-600" data-id="element-149">{lead.source}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-150">
                <span className="text-sm text-gray-600" data-id="element-151">{lead.owner}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-152">
                <Badge variant="default" data-id="element-153">Sent to Five9</Badge>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-154">
                <span className="text-xs text-blue-700 bg-blue-50 px-2 py-1 rounded-md" data-id="element-155">
                  {formatTimeAgo(lead.timeEntered)}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-156">
                <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-157">
                  <Button variant="ghost" size="sm" className="text-gray-500 hover:text-gray-900" onClick={() => onViewDetails(lead, 'Sent')} title="View Details" data-id="element-158">
                    <EyeIcon className="w-4 h-4" data-id="element-159" />
                  </Button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}